import React from 'react'

import Button from './Button';
import PicCont from './PicCont';
import { SHOW_POPUP } from '../store/slices/ui';
import { useDispatch, useSelector } from 'react-redux';
import calculator from '../public/Pictures/builder-example.png'
import concertP from '../public/Pictures/builder-example-concert.png'
import { useRouter } from 'next/router';
import AudioAction from './design-system/audio/AudioAction';
import BuilderPromoV2 from './design-system/marketing/BuilderPromoV2';
import { useOrderFlow } from './unified-order/OrderFlowProvider';
import ProductionPopup from './DeferredProductionPopup';

const BuilderPromo = ({ home, concert, ui }) => {
    let dispatch = useDispatch()
    let {pathname} = useRouter()
    let orlando = pathname?.includes('orlando')
    let { launchIntent } = useOrderFlow()
    const startBuilder = () => launchIntent({
        sourceSurface: 'builder_promo',
        fulfillment: 'delivery_setup'
    }, () => dispatch(SHOW_POPUP({ size: 'xl', key: 'prodpop', body: <ProductionPopup /> })))

    if (ui === 'v2') {
        let steps = [
            <>Select the AV services and equipment your event may need.</>,
            <>Add the venue, dates, and schedule, then preview the setup and preliminary pricing.</>,
            <>Complete an eligible rental online or ask our team for <strong>personalized assistance</strong>.</>,
            <>Save the project to continue later or share it with collaborators.</>,
        ]

        return <BuilderPromoV2
            image={concert ? concertP : calculator}
            intro={home ? 'Introducing Our Event Builder' : <>Try our Event Builder and <strong>save time, boost collaboration, avoid unnecessary back and forth</strong> and <strong>last minute stress.</strong></>}
            motionProfile={home ? 'homepage' : 'static'}
            onStart={startBuilder}
            question={orlando ? 'Are you renting different types of Audio Visual equipment?' : 'Do you need to rent several types of AV equipment for your event?'}
            steps={steps}
        />
    }

    return            <section className='builderPromo'>
    <h3 className='upperBold'>{orlando ? 'Are you renting different types of Audio Visual equipment?' :'Do you need to rent several types of AV equipment for your event?'}</h3>
    <div className='row'>
        <div className='col'>
       {home ? <h4 className='thick'>Introducing Our Event Builder</h4> :      <h4 >Try our Event Builder and <strong>save time, boost collaboration, avoid unnecessary back and forth</strong> and <strong>last minute stress.</strong></h4>}
            <div className='rowWrap' >
                <p> <strong className='numberStrong' >1.</strong>
                Transform your event ideas into reality by selecting AV equipment from our categories.
                 </p>
                <p> <strong className='numberStrong'>2.</strong>
                Set times and location. Build a <strong>lifelike view</strong> of your setup. We automatically calculate your <strong>final price</strong> and timing details.
                 </p>
                <p> <strong className='numberStrong'>3.</strong>
                Review your order&apos;s details and finish your rent by paying online or <strong>call us</strong> to get <strong>personallized assistance</strong>.
                 </p>
                <p> <strong className='numberStrong'>4.</strong>
                You can also <strong>save your project</strong> for working on it later or share it to collaborate.
                 </p>
                 </div>

            <div className='buttons'>
                {ui === 'v2'
                  ? <AudioAction mode='primary' size='large' onClick={startBuilder}>BUILD MY EVENT ORDER</AudioAction>
                  : <Button onClick={startBuilder} className='btn-4 animated highLight ' >BUILD MY EVENT ORDER</Button>}
            </div>
        </div>
        <div className='imgPar'>
        <PicCont height={690} width={940} src={concert ? concertP : calculator} />
        </div>
    </div>
</section>
}

export default BuilderPromo
